module.exports = __webpack_public_path__ + "static/img/tdbig2.0b9275c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/tdbig2.jpg
// module id = acRL
// module chunks = 0